import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Select from "react-select";

import user from "./../../../../assets/images/profile/pic1.jpg";
import { countries } from "../../Admin/CommanPage/countries";
import { getUserProfile } from "../../../../api/auth";
import { updateUser } from "../../../../api/user";

const genderOptions = [
  { value: "male", label: "Male" },
  { value: "female", label: "Female" },
  { value: "other", label: "Other" },
];

const countryOptions = countries.map((country) => ({
  value: country.code,
  label: `${country.emoji} ${country.name} (${country.dial_code})`,
}));

const EditProfile = () => {
  const [profile, setProfile] = useState(null);
  const [form, setForm] = useState({
    firstName: "",
    lastName: "",
    gender: "",
    birth: "",
    mobile: "",
    email: "",
    country: "",
  });

  useEffect(() => {
    const fetchProfile = async () => {
      try {
        const data = await getUserProfile();
        setProfile(data);

        setForm({
          firstName: data.firstName || "",
          lastName: data.lastName || "",
          gender: data.gender || "",
          birth: data.birth || "",
          mobile: data.mobile || "",
          email: data.email || "",
          country: data.country || "",
        });
      } catch (err) {
        console.error("Error fetching profile", err);
      }
    };

    fetchProfile();
  }, []);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSelectChange = (field, value) => {
    setForm({ ...form, [field]: value?.value || "" });
  };

  const handleUpdate = async () => {
    try {
      const payload = {
        ...profile,
        id: profile.id,
        email: form.email,
        firstName: form.firstName,
        lastName: form.lastName,
        mobile: form.mobile,
        isActive: true, // required by Swagger
      };

      await updateUser(payload);
      alert("Profile updated successfully ✅");
    } catch (err) {
      console.error("Update failed", err);
      alert("Something went wrong ❌");
    }
  };

  return (
    <div className="row">
      <div className="col-xl-3 col-lg-4">
        <div className="clearfix">
          <div className="card card-bx profile-card author-profile m-b30">
            <div className="card-body">
              <div className="p-5">
                <div className="author-profile">
                  <div className="author-media">
                    <img src={user} alt="" />
                    <div className="upload-link" data-toggle="tooltip">
                      <input type="file" className="update-flie" />
                      <i className="fa fa-camera"></i>
                    </div>
                  </div>
                  <div className="author-info">
                    <h6 className="title">
                      {form.firstName} {form.lastName}
                    </h6>
                    <span>{profile?.userType || "User"}</span>
                  </div>
                </div>
              </div>
              <div className="info-list">
                <ul>
                  <li>
                    <Link to={"/app-profile"}>Models</Link>
                    <span>36</span>
                  </li>
                  <li>
                    <Link to={"/uc-lightgallery"}>Gallery</Link>
                    <span>3</span>
                  </li>
                  <li>
                    <Link to={"/app-profile"}>Lessons</Link>
                    <span>1</span>
                  </li>
                </ul>
              </div>
            </div>
            <div className="card-footer">
              <div className="input-group mb-3">
                <div className="form-control rounded text-center bg-white">
                  Portfolio
                </div>
              </div>
              <div className="input-group">
                <Link
                  to="/"
                  target="blank"
                  className="form-control text-primary rounded text-start bg-white"
                >
                  PINANCE
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Right Side - Form */}
      <div className="col-xl-9 col-lg-8">
        <div className="card profile-card card-bx m-b30">
          <div className="card-header">
            <h6 className="title">Account setup</h6>
          </div>

          <form className="profile-form">
            <div className="card-body">
              <div className="row">
                <div className="col-sm-6 m-b30">
                  <label className="form-label">First Name</label>
                  <input
                    type="text"
                    name="firstName"
                    className="form-control"
                    value={form.firstName}
                    onChange={handleChange}
                  />
                </div>

                <div className="col-sm-6 m-b30">
                  <label className="form-label">Last Name</label>
                  <input
                    type="text"
                    name="lastName"
                    className="form-control"
                    value={form.lastName}
                    onChange={handleChange}
                  />
                </div>

                <div className="col-sm-6 m-b30">
                  <label className="form-label">Gender</label>
                  <Select
                    options={genderOptions}
                    className="custom-react-select"
                    value={
                      genderOptions.find((o) => o.value === form.gender) || null
                    }
                    onChange={(val) => handleSelectChange("gender", val)}
                    isSearchable={false}
                  />
                </div>

                <div className="col-sm-6 m-b30">
                  <label className="form-label">Birth</label>
                  <input
                    type="date"
                    name="birth"
                    className="form-control"
                    value={form.birth}
                    onChange={handleChange}
                  />
                </div>

                <div className="col-sm-6 m-b30">
                  <label className="form-label">Phone</label>
                  <input
                    type="number"
                    name="mobile"
                    className="form-control"
                    value={form.mobile}
                    onChange={handleChange}
                  />
                </div>

                <div className="col-sm-6 m-b30">
                  <label className="form-label">Email address</label>
                  <input
                    disabled
                    type="text"
                    name="email"
                    className="form-control"
                    value={form.email}
                  />
                </div>

                <div className="col-sm-6 m-b30">
                  <label className="form-label">Country</label>
                  <Select
                    options={countryOptions}
                    className="custom-react-select"
                    value={
                      countryOptions.find((c) => c.value === form.country) ||
                      null
                    }
                    onChange={(val) => handleSelectChange("country", val)}
                    isSearchable={true}
                  />
                </div>
              </div>
            </div>

            <div className="card-footer">
              <button
                type="button"
                className="btn btn-primary"
                onClick={handleUpdate}
              >
                UPDATE
              </button>
              <Link to={"#"} className="btn-link">
                Forgot your password?
              </Link>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default EditProfile;
